<template>
    <div class="projects">
        <box-helper
            headline="Opgaver"
            identifier="projects"
        />
        <div class="container section">
            <title-block headline="<b>Opgaver</b>" class="mb-xl" position="center">
                <p slot="text">
                    Ét samlet overblik over dine opgaver
                </p>
            </title-block>

            <view-toggle
                operationsName="Drift"
                operationsLink="ProjectsOperations"
                learningName="Udvikling / læring"
                learningLink="ProjectsLearning"
            />

            <router-view />
            
        </div>
    </div>
</template>

<style lang="scss">
@import "../../styles/vars.scss";

.sidebar-menu {
    background: none;
    margin-bottom: $margin--main;

    .items {
        display: flex;
        justify-content: flex-start;

        &.six-columns {
            .item {
                width: calc(16.66% - 10px) !important;

                &:not(:first-of-type) {
                    margin-left: 12px;
                }
            }
        }

        .item {
            padding: $padding--small;
            width: calc(20% - 10px);
            text-align: center;
            font-size: $fontsize--sm;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            box-sizing: border-box;
            background: $color--white;
            border-radius: $borderradius--main;
            box-shadow: $boxshadow--creative;
            min-height: 100px;

            .coming-soon {
                font-weight: bold;
                margin-bottom: $margin--small / 2;
            }

            &:not(:first-of-type) {
                margin-left: 12.5px;
            }

            .inner {
                width: 100%;
            }

            &:hover {
                background: #efefef;
            }

            &.selected {
                background: $color--dark;
                color: $color--white;
            }

            .name {
                flex-grow: 1;
            }

            .count {
                font-size: $fontsize--large;
                font-weight: $fontweight--bold;
            }

            .icon {
                position: absolute;
                bottom: -15px;
                left: 50%;
                transform: translate(-50%, 0);

                svg {
                    height: 15px;

                    polygon {
                        fill: $color--dark;
                    }
                }
            }
        }
    }
}

.green {
    // background: rgba(green, 0.25);
}
.red {
    // background: rgba(red, 0.25);
}
</style>

<script>

export default {
    data () {
        return {
            showHelper: false,
            selectedTable: 'closedProjectsRevenue',
            counts: {
                closedProjectsRevenue: null,
                ongoingProjects: null,
                snoozedProjects: null,
                openClaims: null,
                openProjects: null
            },
            sidebarMenuItems: [
                {
                    name: 'Hvilke opgavetyper tjenes der penge på?',
                    tableName: 'projectTypeRevenue'
                },
                {
                    name: 'Hvilke konkrete opgaver tjenes der penge på?',
                    tableName: 'closedProjectsRevenue'
                },
                {
                    name: 'Igangværende opgaver',
                    tableName: 'ongoingProjects'
                },
                {
                    name: 'Opgaver uden bevægelse de sidste ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                    tableName: 'snoozedProjects'
                },
                {
                    name: 'Igangværende reklamationer',
                    tableName: 'openClaims'
                },
                {
                    name: 'Ikke igangsatte opgaver',
                    tableName: 'openProjects'
                }
            ],
            goodTable: {
                columns: [
                    {
                        label: 'Opgavetype',
                        field: 'type.name',
                        type: 'string'
                    },
                    {
                        label: 'Opgave',
                        field: 'description',
                        type: 'string',
                        width: '20%'
                    },
                    {
                        label: 'Kunde',
                        field: 'customer.name',
                        type: 'string'
                    },
                    {
                        label: 'Omsætning',
                        field: 'revenue',
                        type: 'number'
                    },
                    {
                        label: 'DB',
                        field: 'coverage',
                        width: '10%',
                        type: 'number'
                    },
                    {
                        label: 'DG',
                        field: 'coverage_percent',
                        width: '8%',
                        type: 'number'
                    },
                    {
                        label: 'DB/time',
                        field: 'coverage_per_hour',
                        width: '8%',
                        type: 'number'
                    }
                ],
                rows: []
            }
        }
    },
    computed: {},
    methods: {
        onRowClick (params) {
            console.log(params)
            // window.open('https://system.ordrestyring.dk/cases/6299/order/overview', '_blank')
        },
        rowStyleClassFn (row) {
            return row.age > 18 ? 'green' : 'red'
        },
        updateCount (tableName, event) {
            this.counts[tableName] = event
        }
    }
}
</script>



// WEBPACK FOOTER //
// projects.vue?50af5967